import { Box, Typography } from '@mui/material';
import { getPasswordChecks, PASSWORD_SPECIAL_CHARS } from '../utils/passwordComplexity';

const RULES = [
  { key: 'minLength', label: 'At least 8 characters' },
  { key: 'uppercase', label: 'One uppercase letter' },
  { key: 'lowercase', label: 'One lowercase letter' },
  { key: 'number', label: 'One number' },
  { key: 'special', label: `One special character (${PASSWORD_SPECIAL_CHARS})` }
];

export default function PasswordRequirements({ password, confirmPassword, showMatch = true, sx }) {
  const checks = getPasswordChecks(password, confirmPassword);
  const items = showMatch ? [...RULES, { key: 'match', label: 'Passwords must match' }] : RULES;

  return (
    <Box component="ul" sx={{ m: 0, pl: 2.5, ...sx }}>
      {items.map((rule) => (
        <Typography
          key={rule.key}
          component="li"
          variant="caption"
          sx={{
            display: 'list-item',
            color: checks[rule.key] ? 'success.main' : 'text.secondary',
            fontWeight: checks[rule.key] ? 600 : 400
          }}
        >
          {rule.label}
        </Typography>
      ))}
    </Box>
  );
}
